import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import {
  AppNotifications,
  FORM_MODE,
  RootState,
  TCb,
  LanguageOutputModel,
  FaqOutputModel,
  FaqInputModel,
} from "../../../models";
import { FaqService } from "../../../services";
import { NotificationActions, AllLanguageListActions } from "../../../store/actions";
import FaqFormPresenter from "./FaqForm.presenter";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./FaqForm.type";
import { loadCallback } from "../../../utils";
import { withRouter } from "react-router-dom";

class FaqFormContainer extends Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    this.state = {
      mode: FORM_MODE.CREATE,
      loading: false,
      initData: null,
      activeLang: this.props.all_language_list.data.find((e: LanguageOutputModel) => e.isPrimary)?.id,
      languageOptions: this.props.all_language_list.data,
    };
  }

  onSubmit = (val: any) => {
    let newArr: FaqInputModel[] = [];
    this.state.languageOptions.forEach((e) => {
      if (val[`question${e.id}`] || val[`answer${e.id}`]) {
        let newObj: FaqInputModel = {
          languageId: e.id,
          question: val[`question${e.id}`] || "",
          answer: val[`answer${e.id}`] || "",
        };
        const found = this.state.initData?.find((i) => i.languageId === e.id);
        if (this.state.mode !== FORM_MODE.CREATE && found) {
          newObj.id = found.id;
        }
        newArr.push(newObj);
      }
    });

    if (newArr.length === 0) {
      this.props.actions.enqueueSnackbar({
        type: AppNotifications.ERROR,
        message: "Please input FAQ content",
      });
      return;
    }

    if (this.state.mode === FORM_MODE.CREATE) {
      this.onCreateFaq(newArr);
    } else {
      this.onUpdateFaq(newArr);
    }
  };

  onCreateFaq = (data: FaqInputModel[]) => {
    FaqService.createFaq(data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.SUCCESS, message: "Create FAQ success" });
          loadCallback(this.props.onComplete_Create);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create FAQ failed" });
        }
      })
      .catch(() => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create FAQ failed" });
      });
  };

  onUpdateFaq = (data: FaqInputModel[]) => {
    FaqService.updateFaq(this.props.faqCode!, data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.SUCCESS, message: "Edit FAQ success" });
          loadCallback(this.props.onComplete_Update);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Edit FAQ failed" });
        }
      })
      .catch(() => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Edit FAQ failed" });
      });
  };

  onDeleteFaq = () => {
    FaqService.deleteFaq(this.props.faqCode!)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.SUCCESS, message: "Delete FAQ success" });
          loadCallback(this.props.onComplete_Delete);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Delete FAQ failed" });
        }
      })
      .catch(() => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Delete FAQ failed" });
      });
  };

  onLoadFaqDetail = (faqCode: string, cb?: TCb) => {
    this.setState({ loading: true, initData: null }, () => {
      FaqService.getFaqById(faqCode)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            const data: FaqOutputModel = res.data;

            this.setState(
              {
                mode: FORM_MODE.EDIT,
                loading: false,
                initData: [data],
              },
              () => {
                loadCallback(cb?.success);
              },
            );
          } else {
            this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Load data failed" });
            this.props.history.goBack();
          }
        })
        .catch(() => {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Load data failed" });
        });
    });
  };

  onChangeLanguage = (id: string) => {
    this.setState({ activeLang: id });
  };

  render() {
    return (
      <FaqFormPresenter
        {...this.props}
        {...this.state}
        onSubmit={this.onSubmit}
        onDeleteFaq={this.onDeleteFaq}
        onChangeLanguage={this.onChangeLanguage}
      />
    );
  }

  componentDidMount() {
    if (this.props.faqCode) {
      this.onLoadFaqDetail(this.props.faqCode);
    }
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions, AllLanguageListActions), dispatch),
    }),
  )(FaqFormContainer),
);
